import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { removeTag, selectTag } from "../../features/filter/filterSlice";

const Tag = ({ title }) => {
    const dispatch = useDispatch();
    const { tags } = useSelector((state) => state.filter);

    const isSelected = tags.includes(title);

    const handleTagSelection = () => {
        if (isSelected) {
            dispatch(removeTag(title));
        } else {
            dispatch(selectTag(title));
            console.log(title);
        }
    };

    return (
        <div
            onClick={handleTagSelection}
            className={`${
                isSelected
                    ? "bg-blue-600 text-white"
                    : "bg-blue-100 text-blue-600"
            } px-4 py-1 rounded-full cursor-pointer`}
        >
            {title}
        </div>
    );
};

export default Tag;
